<template>
  <DetailCard
    v-if="!isLoading"
    key="teslimat-sablonu"
    cardKey="delivery-template"
    title="Teslimat Şablonu"
    :showUpdateButton="false"
    :showApplyToVariants="true"
    @saveChanges="handleSaveChanges"
    v-model:applyToVariants="applyToVariantsState"
    :saveButtonText="dynamicSaveButtonText"
    :isSaved="props.isSaved"
    :showSuccessState="showSuccessState"
    :saveButtonWidth="showSuccessState ? 'auto' : '183px'"
    :isLoading="isLoading"
    :isSaving="isSaving"
    :class="{ disabled: isProductDisabled }"
    :isTemplateSelected="isTemplateSelectedComputed"
  >
    <div class="delivery-template-content" :class="{ disabled: isProductDisabled }">
      <div class="input-with-info">
        <DropdownSelectable
          :preSelectedRadioItem="shipmentTemplateData"
          :hasError="templateValidation"
          :errorText="templateValidation ? 'Teslimat Şablonu zorunludur.' : ''"
          :singleItemTextLength="singleItemTextLength"
          :dropItems="shipmentTemplatesTransform || []"
          :contentBtnClick="navigateCreateNewTemplate"
          :disabled="isProductDisabled"
          @selectedRadioItem="handleDeliveryTemplateSelection"
          label="Teslimat Şablonu Seç"
          notFoundText="Şablon bulunamadı."
          contentBtnText="Yeni Şablon Oluştur"
          :searchDelay="500"
          isRadioGroup
          :dropdownStateProps="deliveryDropdownState"
          @changedDropdownState="handleChangedVariantsDropdownState"
          searchText="Şablon Ara"
        />
        <div v-if="templateValidation" class="basic-input-icon">
          <TooltipPlugin :tooltipText="'Teslimat Şablonu zorunludur.'">
            <template #tooltip-btn>
              <Icons name="AlertCircle" color="#ff6b6b" :size="18" />
            </template>
          </TooltipPlugin>
        </div>
      </div>
      <div v-if="shipmentTemplatesLoading" class="delivery-template-detail">

      </div>
      <template v-else>
        <div class="delivery-template-detail" :class="{ disabled: isProductDisabled }" @click="getTemplateDetail">
          <div class="delivery-template-detail-btn">Şablon Detayını Gör</div>
          <div class="right-arrow">
            <Icons name="RightArrow" :color="isProductDisabled ? '#C7C7C7' : '#FF44EE'" :size="18" />
          </div>
        </div>
      </template>
    </div>

    <!-- Modal -->
    <Modal
      ref="deliveryDetailModalRef"
      :withCloser="true"
      :showIcon="false"
      :modalStyle="{ width: '896px' }"
      :outsideClickDisabled="false"
      positiveActionText="Kapat"
      negativeActionText="Teslimat Bilgilerine Git"
      @onPositiveActionClick="closeModal"
      @onNegativeActionClick="navigateCreateNewTemplate"
    >
      <template v-slot:body>
        <div v-if="templateDetail">
          <div class="shipment-template-details">
            <h1 class="shipment-template-details-title">Şablon Detayları</h1>
            <div class="shipment-template-details-item">
              <p>Şablon Adı</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.templateName || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Teslimat Metodu</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.shipmentMethod ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Depo Adresi</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.warehouseAddress ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
          </div>

          <h1 class="shipment-template-details-subtitle">Kargo Bilgileri</h1>
          <div class="shipment-template-details">
            <div class="shipment-template-details-item">
              <p>Tüm Türkiye'ye gönderim yapıyor musunuz?</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.sendAllCities
                    ? "Evet"
                    : "Hayır" || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Aynı Gün Teslimat yapıyor musunuz?</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.sameDayDeliveryAvailable
                    ? "Evet"
                    : "Hayır" || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div
              class="shipment-template-details-item shipment-template-delivery"
            >
              <p>Kargo Ücreti</p>
              <div class="shipment-template-details-item-fee">
                <p>
                  :
                  {{ templateDetail.deliveryDetail.feeType || "Belirtilmemiş" }}
                </p>
                <p
                  v-if="
                    templateDetail.deliveryDetail.feeType === 'Şartlı Ödeme' &&
                    templateDetail.deliveryDetail.conditionalText
                  "
                >
                  ({{ templateDetail.deliveryDetail.conditionalText }})
                </p>
              </div>
            </div>
            <div class="shipment-template-details-item">
              <p>Birlikte Gönderim</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.combinedShipping ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Kargo Şirketi Seçimi</p>
              <div class="shipment-template-details-item-delivery">
                <p>
                  :
                  {{
                    templateDetail.deliveryDetail.shipmentCompanies.join(
                      ", "
                    ) || "Belirtilmemiş"
                  }}
                </p>
                <p>{{ templateDetail.conditionalText }}</p>
              </div>
            </div>
            <div class="shipment-template-details-item">
              <p>"Bugün Kargoda" sistemine dahil mi?</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.todayDeliveryEnabled ? "Evet" : "Hayır" }}  
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.weekDeliveryCutOffTime != null"
              class="shipment-template-details-item"
            >
              <p>Hafta içi günlerde "Aynı Gün Kargo" için son sipariş saati</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.weekDeliveryCutOffTime }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.saturdayDeliveryCutOffTime != null"
              class="shipment-template-details-item"
            >
              <p>Cumartesi günleri "Aynı Gün Kargo" için son sipariş saati</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.saturdayDeliveryCutOffTime }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.sundayDeliveryCutOffTime != null"
              class="shipment-template-details-item"
            >
              <p>Pazar günleri "Aynı Gün Kargo" için son sipariş saati</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.sundayDeliveryCutOffTime }}
              </p>
            </div>
          </div>

          <h1 class="shipment-template-details-subtitle">
            İade / Değişim Bilgileri
          </h1>
          <div class="shipment-template-details">
            <div class="shipment-template-details-item">
              <p>İade / Değişim Bilgileri</p>
              <div
                class="shipment-template-details-item-address"
                v-if="templateDetail.deliveryDetail.useSameAddress"
              >
                <p>: Depo adresi ile aynı</p>
                <p>({{ templateDetail.deliveryDetail.warehouseAddress }})</p>
              </div>
            </div>
            <div class="shipment-template-details-item">
              <p>İade / Değişim Kargo Şirket Seçimi</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.claimShipmentCompany ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Teslimat Bilgileri</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.shippingInfo || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>İade / Değişim Ek Bilgiler</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.claimInfo || "Belirtilmemiş" }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.useDmallCargo !== null"
              class="shipment-template-details-item"
            >
              <p>İade/Değişim için n11.com Entegrasyonlu Kargo Firması</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.useDmallCargo ? "Evet" : "Hayır"
                }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.installmentInfo !== null"
              class="shipment-template-details-item"
            >
              <p>Satış Sonrası Servis</p>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <p v-html="sanitizedInstallmentInfo"></p>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </DetailCard>
  <div v-else>
    <ProductDeliveryTemplateSkeleton/>
  </div>
</template>

<script setup>
import { ref, computed, defineExpose, onMounted, watch } from "vue";
import { useStore } from "vuex";
import DetailCard from './DetailCard.vue';
import { DropdownSelectable, TooltipPlugin, Modal, Icons } from "@n11/so-ui-components";
import { sendProductDetailEvent } from '@/utils/ga4/helper';
import { GA4_EVENT } from '@/utils/ga4/event';
import { DELIVERY_DETAIL } from "@/utils/enum/endpoints";
import Request from "@/services/request";
import ProductDeliveryTemplateSkeleton from '@/components/Skeleton/ProductDetailSkeleton/ProductDeliveryTemplateSkeleton.vue'

const props = defineProps({
  isSaved: {
    type: Boolean,
    required: true,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  shipmentTemplateData: {
    type: Object,
    default: () => ({})
  }
});

const store = useStore();
const emit = defineEmits(['saveChanges', 'resetSaveStatus']);

const isProductDisabled = computed(() => store.getters['products/isProductDisabled']);

const shipmentTemplates = ref();
const shipmentTemplatesLoading = ref(false);
const singleItemTextLength = ref(80);
const selectedTemplatesIds = ref([]);
const selectedDeliveryTemplate = ref(null);
const deliveryDetailModalRef = ref();
const templateDetail = ref(null);
const deliveryDropdownState = ref(false);
const templateValidation = ref(false);
const applyToVariantsState = ref(true);
const showSuccessState = ref(false);
const isSaving = ref(false);

const getTemplateDetail = async () => {
  if (!selectedTemplatesIds.value || selectedTemplatesIds.value.length === 0) {
   console.warn("No template selected.");
    return;
  }

  const selectedId = selectedTemplatesIds.value[0];
  const request = new Request();

  try {
    const response = await request.get(
      `${DELIVERY_DETAIL}/${selectedId}`,
      null,
      {
        baseURL: "/selleroffice/rest",
        headers: { Accept: "application/json" },
      }
    );
    templateDetail.value = response.data;
    openModal();
  } catch (error) {
    console.error("Error:", error);
    console.warn('Şablon detayları alınırken hata oluştu.');
  }
};

const handleSaveChanges = () => {
  let selectedTemplate = selectedDeliveryTemplate.value;

  if (!selectedTemplate && props.shipmentTemplateData?.id) {
    selectedTemplate = {
      id: props.shipmentTemplateData.id,
      name: props.shipmentTemplateData.name
    };
  }

  const isValid = !!selectedTemplate;

  templateValidation.value = !isValid;

  if (isValid) {
    isSaving.value = true;
    showSuccessState.value = false;
    emit('saveChanges', {
      templateId: Number(selectedTemplate.id),
      templateName: selectedTemplate.name,
      changesAll: applyToVariantsState.value
    });
  } else {
    console.warn('No template selected for save');
  }
};

const getShipmentTemplates = async () => {
  shipmentTemplatesLoading.value = true;
  try {
    const response = await store.dispatch("templates/getShipmentTemplates");
    shipmentTemplates.value = response.data.shipmentTemplates;
  } catch (error) {
    console.error("Error:", error);
  }
  finally {
    shipmentTemplatesLoading.value = false;
  }
};

const shipmentTemplatesTransform = computed(() => {
  return shipmentTemplates.value?.map((item) => ({
    id: item.id,
    name: item.templateName,
  }));
});

const dynamicSaveButtonText = computed(() => {
  return props.isSaved ? 'Değişiklikler Kaydedildi' : 'Değişiklikleri Kaydet';
});

const isTemplateSelectedComputed = computed(() => {
  if (selectedDeliveryTemplate.value) {
    if (selectedDeliveryTemplate.value.id !== props.shipmentTemplateData?.id) {
      return true;
    }
    return false;
  }
  return false;
});

const sanitizedInstallmentInfo = computed(() => {
  if (templateDetail.value?.deliveryDetail?.installmentInfo) {
    return JSON.parse(
      JSON.stringify(templateDetail.value?.deliveryDetail?.installmentInfo)
    );
  }
  return "";
});

const navigateCreateNewTemplate = () => {
  window.open("/selleroffice/product/shippingInformationList", "_blank");
};

const handleDeliveryTemplateSelection = (selection) => {
  if (selection) {
    selectedDeliveryTemplate.value = selection;
    selectedTemplatesIds.value = [selection.id];
    templateValidation.value = false;
  }

  deliveryDropdownState.value = false;
  showSuccessState.value = false;
  emit('resetSaveStatus');
};

const handleChangedVariantsDropdownState = (state) => {
  deliveryDropdownState.value = state;
};

const openModal = () => {
  deliveryDetailModalRef.value?.openModal();
};

const closeModal = () => {
  deliveryDetailModalRef.value?.hiddenModal();
};

const getDeliveryTemplate = () => {
  let selectedTemplate = selectedDeliveryTemplate.value;

  if (!selectedTemplate && props.shipmentTemplateData?.id) {
    selectedTemplate = {
      id: props.shipmentTemplateData.id,
      name: props.shipmentTemplateData.name
    };
  }

  const isValid = !!selectedTemplate;

  templateValidation.value = !isValid;

  return {
    data: { selectedTemplate },
    isValid,
  };
};

watch(() => props.isSaved, (newValue, oldValue) => {
  if (oldValue === false && newValue === true) {
    isSaving.value = false;
    showSuccessState.value = true;
    const productDetail = store.getters['products/getProductDetail'];
    sendProductDetailEvent(GA4_EVENT.SAVE_CHANGES, {
      button_name: 'Değişiklikleri Kaydet',
      button_type: 'Save Changes',
      button_area: 'Delivery Template',
      item_id: productDetail?.id,
      all_variants_checkbox: applyToVariantsState.value,
    });
    selectedDeliveryTemplate.value = null;
  } else if (newValue === false) {
    showSuccessState.value = false;
    isSaving.value = false;
  }
});

watch(() => props.shipmentTemplateData, (newData) => {
  if (newData?.id) {
    selectedTemplatesIds.value = [newData.id];
  }
}, { immediate: true });

defineExpose({
  openModal,
  closeModal,
  getDeliveryTemplate,
  handleSaveChanges,
  resetAfterSaveAll: () => {
    selectedDeliveryTemplate.value = null;
    showSuccessState.value = false;
    isSaving.value = false;
  },
});

onMounted(() => {
  getShipmentTemplates();
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.delivery-template-content {
  display: flex;
  gap: 16px;
  position: relative;

  &.disabled {
    pointer-events: none;
  }
}

.input-with-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  width: 50%;

  span {
    font-size: 11px;
    line-height: 14px;
    color: $colorN60;
    padding: 0 12px;
  }

  .basic-input-icon {
    position: absolute;
    z-index: 1;
    right: 0px;
    top: 11px;
    cursor: pointer;
  }
}

.delivery-template-detail {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 50%;

  &-btn {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
    color: $colorM50;
    white-space: nowrap;
  }

  .right-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;
  }

  &.disabled {
    .delivery-template-detail-btn {
      color: $colorN50;
    }
  }
}

// Modal içeriği için stiller
.shipment-template-details {
  &:not(:last-child) {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d3d6df;
  }

  &-title {
    text-align: left;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
    margin-bottom: 24px;
  }

  .shipment-template-delivery {
    justify-content: start;

    p {
      font-weight: 400;
      width: 300px;
    }
  }

  &-item {
    display: flex;
    flex-direction: row;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    justify-content: space-between;

    &-fee,
    &-address,
    &-delivery {
      display: flex;
      flex-direction: column;
      align-items: start;
      width: 542px;

      p:first-child {
        text-align: start;
        width: 100%;
      }

      p:nth-child(2) {
        font-weight: 400 !important;
        padding-left: 5px;
        margin-top: 4px;
      }
    }

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    p:nth-child(1) {
      font-size: 13px;
      font-weight: 700;
      letter-spacing: -0.05px;
      line-height: 18px;
      max-width: 295px;
      text-align: start;
    }

    p:nth-child(2) {
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      text-align: justify;
      width: 542px;
    }
  }

  &-subtitle {
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.05px;
    margin-bottom: 20px;
  }
}

// Dropdown özelleştirmesi
:deep(.dropdownSelectable-content-list) {
  max-height: 160px;
}

:deep(.section.disabled) {
  .apply-variants {
    pointer-events: none;
    opacity: 0.6;

    input[type="checkbox"] {
      opacity: 0.6;
      cursor: not-allowed;
    }

    label {
      opacity: 0.6;
      cursor: not-allowed;
      color: $colorN60;
    }
  }

  .actions-row {
    button {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

.delivery-template-content {
  :deep(.dropdownSelectable .errorText) {
    left: -11px;
  }
}

</style>
